// @flow
import React, { useContext } from 'react';
import { useEstimateMLDForFieldGuidance } from '@src/custom-hooks/useEstimateMLDForFieldGuidance';

import { FieldArrayGridConfigItemContext } from '../../../../formik-utils/FieldArrayGrid';
import { getMetricNameFromMetricRow } from '../../utils';
import { shouldUseMultiSelectForUsage } from '../../mld-for-field/utils';

import { MultiSelectUsageDropdown } from './MultiSelectUsageDropdown';
import { SingleSelectUsageContainer } from './SingleSelectUsageContainer';

export const DimensionsConfigUsageContainer = () => {
  const mldGuidance = useEstimateMLDForFieldGuidance();
  const { parentContext, rowValues } = useContext(FieldArrayGridConfigItemContext);
  const metricName = getMetricNameFromMetricRow(parentContext);

  return shouldUseMultiSelectForUsage(metricName) ? (
    <MultiSelectUsageDropdown
      metricName={metricName}
      mldGuidance={mldGuidance}
      rowValues={rowValues}
    />
  ) : (
    <SingleSelectUsageContainer
      metricName={metricName}
      mldGuidance={mldGuidance}
      rowValues={rowValues}
    />
  );
};
